export const Cashiers = {
  en: {
    Cashiers: 'Cashiers',
    'Create Cashier': 'Create Cashier',
    Name: 'Name',
    Login: 'Login',
    'Cashier type': 'Cashier type',
    'For online': 'For online',
    'For local': 'For local',
    Active: 'Active',
  },
  ru: {
    Cashiers: 'Кассиры',
    'Create Cashier': 'Создать кассира',
    Name: 'Имя',
    Login: 'Логин',
  },
  uk: {
    Cashiers: 'Касири',
    'Create Cashier': 'Створити касира',
    Name: "Ім'я",
    Login: 'Логін',
    'Cashier type': 'Тип касира',
    'For online': 'Онлайн касир',
    'For local': 'Локальний касир',
    Active: 'Активний',
  },
};

export const CashierForm = {
  en: {
    ...Cashiers.en,
    'New Cashier': 'New Cashier',
    'Edit Cashier': 'Edit Cashier',
    'Update Cashier': 'Update Cashier',
    Password: 'Password',
    'Cash Register License Key': 'Cash Register License Key',
    'Cashier type': 'Cashier type',
    Active: 'Active',
    'Cashier active description':
      'If the cashier is inactive, he is not displayed in Analytics.',
  },
  ru: {
    ...Cashiers.ru,
    'New Cashier': 'Новый Кассир',
    'Edit Cashier': 'Редактирование Кассира',
    'Update Cashier': 'Обновить Кассира',
    Password: 'Пароль',
    'Cash Register License Key': 'Ключ лицензии кассы',
  },
  uk: {
    ...Cashiers.uk,
    'New Cashier': 'Новий Касир',
    'Edit Cashier': 'Редагування Касира',
    'Update Cashier': 'Оновити Касира',
    Password: 'Пароль',
    'Cash Register License Key': 'Ключ ліцензії каси',
    'Cashier type': 'Тип касира',
    Active: 'Активний',
    'Cashier active description':
      'Якщо касир неактивний, він не відображається в Аналітиці.',
  },
};
